module.exports = __webpack_public_path__ + "static/media/banner1.0a3fa4d3.png";